import { USER_CONTACTS_TRACK_USER_IDS } from './userContactsConstants';

export const userContactsTrackUserIds = (userIds) => ({ type: USER_CONTACTS_TRACK_USER_IDS, userIds });
